export default {
  /**
   * Upload BOL document for an appointment
   * @param {string} appointmentId - The appointment UUID
   * @param {File} file - The file to upload
   * @returns {Promise<{id: string}>} - Created BOL ID
   */
  async uploadBol(appointmentId, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('appointmentId', appointmentId);

    const response = await axios.post('/bol/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  },

  /**
   * Get BOL by appointment ID
   * @param {string} appointmentId - The appointment UUID
   * @returns {Promise<Object|null>} - BOL data with original and signed documents
   */
  async getBolByAppointmentId(appointmentId) {
    try {
      const response = await axios.get(`/bol/appointment/${appointmentId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async deleteBol(bolId) {
    await axios.delete(`/bol/${bolId}`);
  }
};
